import React from "react";
import {
  Avatar,
  Card,
  CardContent,
  Container,
  Grid2 as Grid,
  Typography,
} from "@mui/material";
import { reviews } from "../../constants/rewies";

const ReviewCardSection = () => {
  return (
    <Container
      id="Reviews"
      maxWidth="lg"
      sx={{
        pt: 10,
        pb: 0,
      }}
    >
      {/* Heading */}
      <Typography
        variant="h4"
        fontWeight={700}
        align="center"
        gutterBottom
      >
        Join Thousands Of Satisfied Customers
      </Typography>

      <Typography
        variant="body1"
        align="center"
        color="text.secondary"
        sx={{ mb: 8 }}
      >
        Don't just take our word for it. Hear what our customers have to say
        about their experience with Myschoolling
      </Typography>

      {/* Grid */}
      <Grid container spacing={4}>
        {reviews.map((user) => (
          <Grid
            key={user.id}
            xs={12}
            sm={6}
            md={3}
            sx={{ display: "flex" }}
          >
            <Card
              sx={{
                width: "100%",
                maxWidth: 260,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                p: 4,
                borderRadius: "20px",
                border: "1px solid rgba(0,0,0,0.06)",
                boxShadow: "0 10px 30px rgba(0,0,0,0.04)",
                transition: "all 0.3s ease",

                "&:hover": {
                  backgroundColor: "#E6F3FF",
                  transform: "translateY(-6px)",
                  boxShadow: "0 20px 50px rgba(0,0,0,0.08)",
                },
              }}
            >
              <Avatar
                alt={user.name}
                src={user.imageUrl}
                sx={{
                  width: 80,
                  height: 80,
                  mb: 3,
                }}
              />

              <CardContent sx={{ p: 0 }}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 3 }}
                >
                  {user.review}
                </Typography>

                <Typography variant="subtitle2" fontWeight={600}>
                  {user.name}, {user.designation}
                </Typography>

                <Typography variant="caption" color="text.secondary">
                  {user.company}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ReviewCardSection;